<template>
    <div>
        <div v-if="invoice">
            <div>
                <h1 v-translate>Payment Request</h1>
            </div>
            <div>
                <span v-if="paymentUnavailable" class="error-message" v-translate>The direct iDEAL link is currently not setup up correctly. Please contact the sender or try paying manually.</span>
                <div>
                    <div class="box-title">Sent by</div>
                    <span class="box-content">{{ company_profile.name }}</span>
                </div>

                <div>
                    <div class="box-title">Invoice number</div>
                    <span class="box-content">{{ invoice.number }}</span>
                </div>
        
                <div>
                    <div class="box-title" v-translate>Total amount</div>
                    <span class="box-content">{{ invoice.total_amount}} {{ invoice.currency }}</span>
                </div>
                
                <div v-if="!paymentUnavailable" class="payment-button">
                    <GekkoButton @click="onSubmit" :text="$gettext('Pay Now')" />
                    <img style="width:40px; margin-left: 10px" src="/static/images/iDEAL-logo.png">
                </div>
            </div>


            <div class="pdf-preview-wrap" style="position: relative;">
                <iframe class="pdf-preview" v-if="invoice" :src="invoice.pdf_file"></iframe>
            </div>

        </div>

        <div v-if="!invoice && !loading">
            <div>
                <h1 v-translate>Oops this payment request does not seem to exist</h1>
                <div>
                    <div v-translate>Please contact the company that send you this link and report that you received this broken link.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MollieService from '@/store/services/idealpayment.service.js'
import GekkoButton from '@/components/GekkoButton'
import VueDropzone from '@/components/VueDropzone'

export default {
    name: "MolliePaymentStart",
    components: {GekkoButton, VueDropzone},
    data() {
        return {
            invoice: null,
            company_profile: null,
            paymentUnavailable: false,
            loading: true
        }
    },
    created() {
        let uuid = this.$route.params['uuid']

        MollieService.generateMolliePayment(uuid).then((response) => {
            if (response.status !== 204) {
                this.invoice = response.data.invoice
                this.company_profile = response.data.company_profile
                this.paymentUnavailable = response.data.payment_unavailable
            } else {
                this.$router.push({ name: 'MolliePaymentComplete',  params: { uuid: uuid} })
            }
            this.loading = false
        }).catch(()=>{ this.loading = false })
    },
    methods: {
        onSubmit() {
            let uuid = this.$route.params['uuid']

            MollieService.mollieCheckoutUrl(uuid).then((response) => {
                window.location.href = response.data.url
            }).catch((error) => { // redirects if no errors
                if (error.status === 404) {
                    this.$store.commit('setAlert', {
                        title: this.$gettext('Error'),
                        text: this.$gettext('Payment not found'),
                        variant: 'danger',
                        duration: 4
                    })
                } else {
                    this.$store.commit('setAlert', {
                        title: this.$gettext('Error'),
                        text: this.$gettext('Error creating payment link: Invalid access token'),
                        variant: 'danger',
                        duration: 4
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.box-title {
    color: #888;
    font-size: 17px;
}

.box-content {
    font-weight: bold;
    font-size: 18px;
    white-space: nowrap;
}

.payment-button {
    display: flex;
}

.pdf-preview-wrap {
    padding: 0;
    aspect-ratio: 1/1.4142;
    max-width: 800px;
    margin: 0 auto;
}

.pdf-preview {
    height: 100%;
    width: 100%;
    border: 0;
    transition: opacity 0.3s ease;
}

.error-message {
    color: #cd2531;
    font-style: italic;
}
</style>